// extracted by mini-css-extract-plugin
export default {"authApprovalConfirmation":"AuthorizationConfirmation_authApprovalConfirmation__KLRNg","authReviewConfirmation":"AuthorizationConfirmation_authReviewConfirmation__AGhOm"};